import React, { memo } from "react";
import { XAxis, Tooltip, ResponsiveContainer, Line, LineChart, YAxis, Legend, CartesianGrid } from "recharts";
const COLOR = ["#023e7d", "#e57d2f", "#f8bf06", "#0353a4", "#6ea943"];

const CustomizedLegend = (props) => {
    if (props.payload.length) {
        return (
            <ul style={{ listStyle: 'none', display: 'flex', justifyContent: 'center', fontSize: '12px', fontWeight: 600, margin: 0 }}>
                {
                    props.payload.map((entry, index) => (
                        <li key={`item-${index}`} style={{ display: 'flex', marginRight: '16px', alignItems: 'center' }}>
                            <span style={{ width: '16px', height: '8px', backgroundColor: `${COLOR[index]}`, marginRight: '8px', borderRadius: '10px' }}>
                            </span>
                            <span>
                                {entry.dataKey}
                            </span>
                        </li>
                    ))
                }
            </ul>
        );
    } else {

        return " "
    }
}

const formatData = (data, monthsArray) => {

    let arr = [];

    if (data) {
        monthsArray.forEach((month, ind) => {
            let monthObj = {};
            monthObj['month'] = month.name;
            data.forEach(year => {
                monthObj[`${year.Year}`] = parseFloat((year.yeardata[ind].AwsVolume)?.toFixed(0))
            })
            arr.push(monthObj)
        });
    }

    return arr;
}

const BaselineVolumeLineChart = memo((props) => {
    let convertToArray = formatData(props.data.Data, props.months);
    let mapLineChart = convertToArray && Object.keys(convertToArray[0]);
    mapLineChart && mapLineChart.pop();

    return (
        <ResponsiveContainer width={"103%"} height={"100%"}>
            <LineChart
                width={150}
                height={300}
                data={convertToArray}
                margin={{
                    top: 5,
                    right: 60,
                    left: 5,
                    bottom: 5,
                }}
            >
                <XAxis dataKey='month' axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "12px" }} tickLine={false} />
                <YAxis axisLine={{ stroke: '#e6e6e7' }} style={{ fontSize: "12px" }} tickLine={false} padding={{ top: 35 }} />
                <CartesianGrid vertical={false} />

                <Tooltip />
                <Legend content={<CustomizedLegend external={props.data} />} />

                {
                    mapLineChart && mapLineChart.map((item, ind) => (
                        <Line key={ind} type="monotone" dataKey={`${item}`} stroke={`${COLOR[ind]}`} dot={false} strokeWidth={2} />
                    ))
                }

            </LineChart>
        </ResponsiveContainer>

    );
}
)
export default BaselineVolumeLineChart;